module.exports = __webpack_public_path__ + "static/media/4.09e4c955.jpg";